import React from "react";
import { Link } from "gatsby";
import PhoneIcon from "./icons/phone-icon";
import BrandLogo from "./icons/brand-logo";
import ButtonLink from "./ButtonLink";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
    };
  }

  toggleHamburger() {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active",
            })
          : this.setState({
              navBarActiveClass: "",
            });
      }
    );
  }

  render() {
    return (
      <nav
        className="navbar"
        style={{ backgroundColor: "#0A0A0A" }}
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link
              to="/"
              className="navbar-item"
              title="Logo"
              style={{ width: "89px", marginRight: "1.5rem" }}
            >
              <BrandLogo />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              role="menuitem"
              tabIndex={0}
              onKeyPress={() => this.toggleHamburger()}
              onClick={() => this.toggleHamburger()}
              aria-label="Toggle navigation"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered has-text-white">
              <Link className="navbar-item" to="/staff/">
                Attorneys/Staff
              </Link>
              <Link className="navbar-item" to="/practice-areas/">
                Practice Areas
              </Link>
              <Link className="navbar-item" to="/contact/">
                Contact
              </Link>
            </div>
            <div
              className="navbar-end has-text-centered px-1-mobile"
              style={{ alignItems: "center" }}
            >
              <ButtonLink
                className="navbar-item"
                icon={<PhoneIcon />}
                href="tel:(641) 843-4451"
              >
                Call Today
              </ButtonLink>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
